module.exports = __webpack_public_path__ + "static/media/Style5.2b622525.PNG";